<div class="vcard">
	<div class="columnTwoThird">
		<h1>
			<span *ngIf="!isEmpty(person.title)">{{person.title.shorttext}} </span>
			<!-- If possible change to usage of academicdegree.position_of_title -->
			<span *ngIf="!isEmpty(person.academicdegree) && isPrefixTitle()">{{person.academicdegree.shorttext}} {{person.academicdegreesuffix}} </span>
			<span>{{person.firstname}} </span>
			<span *ngIf="!isEmpty(person.nameprefix)">{{person.nameprefix}} </span>
			<span>{{person.surname}}</span>
			<span *ngIf="!isEmpty(person.namesuffix)"> {{person.namesuffix}}</span>
			<span *ngIf="!isEmpty(person.academicdegree) && !isPrefixTitle()">, {{person.academicdegree.shorttext}} {{person.academicdegreesuffix}}</span>
			<br />
			<span *ngIf="!isEmpty(person.artistname)">WIP: Künstlername</span>
		</h1>

		<div class="contact">
			<div *ngIf="postAddresses?.length" class="columnOneThird">
				<psv-person-detail-view-addresses [addresses]="postAddresses"></psv-person-detail-view-addresses>
			</div>
			<div *ngIf="eAddresses?.length" class="columnTwoThird">
				<psv-person-detail-view-contactdata [eAddresses]="eAddresses"></psv-person-detail-view-contactdata>
            </div>
		</div>
		<div class="clearer"></div>
		<br />
		<div *ngIf="!isEmpty(person.affiliations)" class="affiliation">
			<div *ngFor="let affiliation of person.affiliations; let i=index;">
			     <!-- Siehe Ticket 298012: Aufruf des Orgunit Baumes nur dem richtigen Recht -->
			     <div *ngIf="showOrgunitTreeLink === false && isEmpty(affiliation.location) && isEmpty(affiliation.eaddresses); else showNormal">
			        <strong>{{affiliation.organization.text}} &ndash; {{affiliation.affiliationType.text}}<ng-container *ngIf="affiliation.supplement"> {{affiliation.supplement}}</ng-container></strong>
			        <div class="clearer"></div>
			     </div>
			     <br/>
			     <ng-template #showNormal>
                    <button *ngIf="!toggleContact[i]" (click)="toggleContactDataForAffiliation(true, i)"
                    class="icon" title="{{'cs.psv.person.affiliation.showContactdata' | hisUi}}">
                        <strong>{{affiliation.organization.text}} &ndash; {{affiliation.affiliationType.text}}<ng-container *ngIf="affiliation.supplement"> {{affiliation.supplement}}</ng-container></strong>
                        <img hisImage="ARROW_RIGHT_V" class="inlineicon" title="{{ ('view.images.plus_circ' | hisUi) }}">
                    </button>
                    
                    <button *ngIf="toggleContact[i]" (click)="toggleContactDataForAffiliation(false, i)"
                        class="icon" title="{{'cs.psv.person.affiliation.hideContactdata' | hisUi}}">
                    <strong>{{affiliation.organization.text}} &ndash; {{affiliation.affiliationType.text}}<ng-container *ngIf="affiliation.supplement"> {{affiliation.supplement}}</ng-container></strong>
                    <img hisImage="ARROW_UP_V" class="inlineicon" title="{{ ('view.images.minus_circ' | hisUi) }}">
                    </button>
                    <br />
                </ng-template>
				
				
				<ng-container *ngIf="toggleContact[i]">
				    <!--  Siehe Ticket 298012: Aufruf des Orgunit Baumes nur dem richtigen Recht -->
				    <div *ngIf="showOrgunitTreeLink === true">
					    <a title="{{ 'cs.psv.orgunit.publicOrgunit.showOrgunitTree' | hisUi}}" class="singleLine transparent"
						    href="../../pages/startFlow.xhtml?_flowId=showPublicOrgunitHierarchy-flow&personOrgunitRelationId={{affiliation.id}}&object=PersonOrgunitRelation&showOrgunitTree=true&backToPersonProfile=true&navigationPosition=organisation,hisinonepubliceinrichtungsstruktur"
						    hisImage="CHART_ORGANISATION">{{ 'cs.psv.orgunit.publicOrgunit.showOrgunitTree' | hisUi}}</a>
					    <br /><br />
					</div>
					<div class="contact">
					<br />
					<div class="layoutBlock" *ngIf="!isEmpty(affiliation.location) || !isEmpty(affiliation.eaddresses)">
						<div class="columnOneThird" *ngIf="affiliation.location">
							<psv-person-detail-view-addresses [addresses]="[affiliation.location]"></psv-person-detail-view-addresses>
						</div>
						<br />
						<div class="columnTwoThird" *ngIf="affiliation.eaddresses">
							<psv-person-detail-view-contactdata [eAddresses]="affiliation.eaddresses"></psv-person-detail-view-contactdata>
						</div>
					</div>
					<br *ngIf="i < person.affiliations.length-1" />
					</div>
				</ng-container>
				<div class="clearer"></div>
			</div>
		</div>
	</div>
	<div class="columnOneThird">
<!-- 	WIP: Profilbild (aus PSV?)
		<img src="person.picture" alt="getFullPersonNameAndTitle()"
			title="{{'psv.Person' | hisUi}}: getFullPersonNameAndTitle()" class="detailpagePersonFoto">
 --></div>
	<div class="clearer"></div>
</div>
